import React, { Component } from 'react';
import { View } from '../UIElements/All.js';
import { Colors } from '../Managers/ThemeManager';
import { isRetail } from '../Managers/Utils';
import Loc from './Localization'

export default class Header extends Component 
{
  constructor(props) 
  {
    super(props);
    var state = {};
    this.state = state;
  }

  setIsUpdating(isUpdating)
  {
    this.setState({isUpdating});
  }

  getModal()
  {
    return this._modal;
  }

  render() 
  {
    if( !isRetail() ) return null;

  	var self = this;
    var style = typeof this.props.style === 'undefined' ? {} : this.props.style;
    style.backgroundColor = Colors.background2;
    style.height = 60;
    style.flex = -1;
    style.alignSelf = 'stretch';
    style.flexDirection = "row";
    style.alignItems = 'center';
    style.boxShadow = "0 4px 8px 0 rgba(0, 0, 0, 0.15), 0 6px 20px 0 rgba(0, 0, 0, 0.14)";
    
    return (
      <View style={style}>
        <View style={{flex:-1, width:40, textAlign:'center', justifyContent:'center', fontSize:22, color:Colors.text1, marginRight:8}}>
        {}
        </View>
        <View style={{flex:-1, fontSize:22, color:Colors.text2, marginRight:8}}>
          <Loc locKey="CURRENT_SALE_HEADER_TTILE"></Loc>
        </View>
        <View style={{flex:-1, fontSize:22, color:Colors.text1, marginRight:8}}>
        {">"}
        </View>
        <View style={{flex:-1, fontSize:22, color:Colors.text1, marginRight:8}}>
          <Loc locKey="LOYALTY_HEADER_TTILE"></Loc>
        </View>
        <View style={{flex:1}} />
      {this.props.children}
      </View>
    );
  }
}

